import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden bg-[#0000014d]" }
const _hoisted_4 = { class: "pointer-events-none fixed md:inset-y-0 bottom-0 right-0 flex max-w-full md:pl-10" }
const _hoisted_5 = { class: "relative flex-1 px-4 sm:px-6" }
const _hoisted_6 = { class: "flex flex-col h-full" }
const _hoisted_7 = { class: "w-full flex-1" }
const _hoisted_8 = { class: "mt-5 w-full" }
const _hoisted_9 = { class: "flex justify-end" }

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPanel',
  props: {
    show: {
        type: Boolean,
        default: false
    },
    customClass: {
        type: String,
        default: "overflow-y-scroll"
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: __props.show
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-300",
                    "enter-from": "md:translate-x-full md:translate-y-[unset] translate-y-full",
                    "enter-to": "md:translate-x-0 md:translate-y-[unset] translate-y-0",
                    leave: "transform transition ease-in-out duration-300",
                    "leave-from": "md:translate-x-0 md:translate-y-[unset] translate-y-0",
                    "leave-to": "md:translate-x-full md:translate-y-[unset] translate-y-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "pointer-events-auto w-screen md:max-w-sm" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex md:h-full flex-col bg-white py-6 md:rounded-l-md rounded-tl-md md:rounded-tr-none rounded-tr-md shadow-xl", __props.customClass])
                          }, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(DialogTitle), { class: "text-lg font-semibold mb-5" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Filter ")
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_7, [
                                  _renderSlot(_ctx.$slots, "fields")
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(ButtonComponent, {
                                      size: "large",
                                      btnWidth: "quinary",
                                      class: "mr-2",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Close")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(ButtonComponent, {
                                      size: "large",
                                      btnWidth: "quinary",
                                      class: "mr-2",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('apply:reset')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Reset")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(ButtonComponent, {
                                      size: "large",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('apply:filters')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Filter")
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ], 2)
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}
}

})